import * as React from 'react';
const SvgTube = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 20 20" fill="none" {...props}>
        <path
            d="M8.654 5.73v2.078a1.01 1.01 0 01-.096.44l-4.58 8.13a.497.497 0 000 .515.502.502 0 00.201.196c.085.048.18.074.278.075h11.115a.575.575 0 00.48-.271.478.478 0 00.066-.253.505.505 0 00-.067-.262l-4.57-8.13a1.002 1.002 0 01-.115-.44v0-5.871a.918.918 0 01.278-.665.96.96 0 01.68-.272h1.524c.168 0 .334.042.48.125.147.082.269.2.353.343a.92.92 0 010 .937v0a.947.947 0 01-.352.344.975.975 0 01-.482.124h-.546v4.683l4.38 7.885c.285.487.384 1.059.277 1.61v0a2.368 2.368 0 01-.848 1.408 2.469 2.469 0 01-1.576.54H4.457a2.469 2.469 0 01-1.576-.54 2.368 2.368 0 01-.848-1.407v0a2.315 2.315 0 01.316-1.61v0l4.389-7.868V2.892h-.556a.975.975 0 01-.476-.127.948.948 0 01-.348-.341.92.92 0 010-.937v0a.977.977 0 01.824-.375h1.504a.969.969 0 01.671.281c.18.173.284.409.288.656v3.68h.01z"
            fill="currentColor"
            stroke="currentColor"
            strokeWidth={0.3}
        />
    </svg>
);
export default SvgTube;
